











































import { Component, Vue, Watch } from "vue-property-decorator";
import { dangisWiki as wiki } from "@/config/host.config";

import { IWikiObject as IWiki, IWikiCategory } from "@/@types/wiki/wiki-object";
import { IWikiType } from "@/@types/wiki/wiki_types";
import { deleteElement } from "@/api/delite/delite-element";

import FullWikiList from "@/components/tables/wiki/full-wiki-list.vue";
import ChangeWiki from "@/components/tables/wiki/change-wiki.vue";
import AddWikiCategoryModal from "@/components/tables/wiki/add-wiki-category-modal.vue";
import WikiHeader from "@/components/tables/wiki/wiki-header.vue";
import WikiConfigSettings from "@/components/tables/wiki/wiki-config-settings.vue";

@Component({
  name: "WikiList",
  components: {
    WikiHeader,
    FullWikiList,
    AddWikiCategoryModal,
    ChangeWiki,
    WikiConfigSettings,
  },
})
class WikiList extends Vue {
  full_wikis: Array<IWiki> = [];
  short_wikis: Array<IWiki> = [];
  categorys: Array<IWikiCategory> = [];

  category_id = "";

  show = false;
  deleted = false;

  // Переменные для управления загрузкой
  itemsPerPage = 10; // Количество элементов для подгрузки
  isLoading = false;

  get mainCategorys(): Array<IWikiCategory> {
    return this.categorys.filter((c) => {
      if (c.type == IWikiType.main) return c;
    });
  }

  get subCategorys(): Array<IWikiCategory> {
    return this.categorys.filter((c) => {
      if (c.type == IWikiType.sub) return c;
    });
  }

  updatecatlist(id: string, data: IWikiCategory): void {
    const i = this.categorys.findIndex((el) => el._id == id);
    if (i < 0) this.categorys.push(data);
    else this.$set(this.categorys, i, data);
  }

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  async dropCollection(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete-all")),
        }
      );

      if (result === true) {
        this.full_wikis.forEach((el) => this.deleteWikiObject(el._id));
      }
    } catch {
      this.isError();
    }
  }

  deleteWikiObject(id: string | undefined): void {
    if (!id) return this.isError();
    const uri = this.deleted ? wiki.force : wiki.mainAPI;
    deleteElement(id, uri).then(() => {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
      this.clearWikiList(id);
      this.$bvModal.hide("full-wiki-card");
    });
  }

  async clearWikiList(id: string): Promise<void> {
    const i = this.full_wikis.findIndex((el) => el._id == id);
    if (i < 0) return this.createWikiList();
    this.full_wikis.splice(i, 1);

    const j = this.short_wikis.findIndex((el) => el._id == id);
    if (j < 0) return this.createMiniList();
    this.short_wikis.splice(i, 1);
  }

  async restoreWikiObject(id: string | undefined): Promise<void> {
    if (!id) return this.isError();
    const uri = wiki.restore + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.clearWikiList(id);
      }
    } catch (e) {
      console.log(e);
      this.isError();
    }
  }

  updateWikiObjCount(): void {
    this.show = false;
    if (this.short_wikis.length < this.full_wikis.length)
      this.short_wikis = this.full_wikis;
    else this.short_wikis = this.full_wikis.slice(0, 100);

    setTimeout(() => {
      this.show = true;
    }, this.$second(1));
  }

  async changeWikiObj(data: Partial<IWiki>, id: string): Promise<void> {
    const uri = id ? wiki.mainAPI + "/" + id : wiki.mainAPI;
    const method = id ? "put" : "post";
    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$bvModal.hide("change-wiki");

        const i = this.full_wikis.findIndex((el) => el._id == id);
        if (!id || i < 0) {
          this.full_wikis.push(res.data);
          this.short_wikis.unshift(res.data);
          return;
        }
        this.$set(this.full_wikis, i, res.data);
        const j = this.full_wikis.findIndex((el) => el._id == id);
        if (j < 0) {
          this.short_wikis.unshift(res.data);
          return;
        }
        this.$set(this.short_wikis, i, res.data);
      }
    } catch (e) {
      console.error(e);
      this.isError();
    }
  }

  // Функция для загрузки данных (замените на реальный запрос)
  loadItems(): void {
    if (this.isLoading) return;
    const content = document.getElementById("item-list")?.clientHeight;

    const screenHeight = window.innerHeight;
    const scrolled = window.scrollY;
    const position = scrolled + screenHeight; // низ экрана относительно страницы
    if (!content || position + 100 < content) return;
    this.isLoading = true;

    this.short_wikis = this.full_wikis.slice(
      0,
      this.short_wikis.length + this.itemsPerPage
    );
    this.isLoading = false;
  }

  // +

  createMiniList(): void {
    const wikis = this.full_wikis.reverse();
    this.short_wikis = wikis.slice(0, 100);
    this.$nextTick(() => (this.show = true));
  }

  async getWikiCategorys(): Promise<void> {
    const uri = wiki.categorys.main;
    const params = { "match[deleted][value]": false };
    try {
      const catres = await this.$axios.get(uri, { params });
      if (catres.status === 200) this.categorys = catres.data;
    } catch (error) {
      console.error(error);
    }
  }

  @Watch("deleted")
  async createWikiList(): Promise<void> {
    const url: string = wiki.getAllDots;
    const params = { "match[deleted][value]": this.deleted };
    try {
      const wikiRes = await this.$axios.get(url, { params });
      if (wikiRes.status === 200) {
        this.full_wikis = wikiRes.data;
        this.createMiniList();
        this.changeRadius(wikiRes.data);
      }
    } catch (error) {
      console.error(error);
      this.$nextTick(() => (this.show = true));
    }
  }

  changeRadius(wikis: Array<IWiki>): void {
    wikis.forEach((wiki) => {
      if (wiki.location && wiki.location.radius > 1) {
        const location = wiki.location;
        location.radius = wiki.location.radius / 111144;
        this.changeWikiObj({ location }, wiki._id);
      }
    });
  }

  mounted(): void {
    this.createWikiList();
    this.getWikiCategorys();
    window.addEventListener("scroll", this.loadItems);
  }

  beforeDestroy(): void {
    window.removeEventListener("scroll", this.loadItems);
  }
}
export default WikiList;
